<div class="card border-0">
  <div class="card-header border-0 bg-warning">
    {{
      data.activeTab == "notifications"
        ? data.notification.pushNotificationHeader
        : data.notification.announcementHeader
    }}
    <span (click)="dialogRef.close()" class="float-end clickable">
      <i
        class="fa fa-times p-2 py-1 shadow bg-light"
        style="border-radius: 5px"
      ></i>
    </span>
  </div>
  <div class="card-body" style="max-height: 80vh; overflow-y: scroll;">
    <div class="card-text">
      <app-rich-text-renderer
        [text]="
          data.activeTab == 'notifications'
            ? data.notification.pushNotificationMessage
            : data.notification.announcementMessage
        "
      ></app-rich-text-renderer>
    </div>
  </div>
</div>
